export default __webpack_public_path__ + "static/BicstoneIcon-6795828b2d79f775420426f439cc9ca1.svg";